// SVG-графіка сторінки ящика. Сам ящик має власні «військові» кольори, світіння береться з теми.

// Дерев'яний ящик у стилі DayZ (великий дерев'яний ящик). Кришка — окремий шар .case-crate-lid,
// який від'їжджає назад (вздовж глибини ящика) при наведенні й під час відкриття; з-під неї б'є світло.
export const CrateArt = ({ className = "" }: { className?: string }) => (
    <svg className={`case-crate ${className}`} viewBox="0 -10 320 240" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="crate-front" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#a07f53" />
                <stop offset="1" stopColor="#6b5233" />
            </linearGradient>
            <linearGradient id="crate-end" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#6b5233" />
                <stop offset="1" stopColor="#47361f" />
            </linearGradient>
            <linearGradient id="crate-top" x1="0" y1="1" x2="0.2" y2="0">
                <stop offset="0" stopColor="#bc9b6d" />
                <stop offset="1" stopColor="#977850" />
            </linearGradient>
            <linearGradient id="crate-batten" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#c6a678" />
                <stop offset="0.75" stopColor="#a98659" />
                <stop offset="1" stopColor="#7a5e3e" />
            </linearGradient>
            <linearGradient id="crate-inside" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#3a2a18" />
                <stop offset="1" stopColor="#1f160b" />
            </linearGradient>
            <linearGradient id="crate-ammo" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#cfd2d8" />
                <stop offset="0.45" stopColor="#b5463b" />
                <stop offset="1" stopColor="#7a2a24" />
            </linearGradient>
            <radialGradient id="crate-glow" cx="0.5" cy="1" r="0.85">
                <stop offset="0" stopColor="#fff6c9" />
                <stop offset="0.35" stopColor="#ffc43b" stopOpacity="0.9" />
                <stop offset="1" stopColor="#ffc43b" stopOpacity="0" />
            </radialGradient>
        </defs>

        {/* тінь */}
        <ellipse className="case-crate-shadow" cx="168" cy="220" rx="132" ry="11" fill="#000" fillOpacity="0.3" />

        {/* нутро ящика — видно, коли кришка від'їжджає */}
        <path d="M78 132H292L258 76H44Z" fill="url(#crate-inside)" />
        <path d="M44 76H258L262 84H49Z" fill="#000" fillOpacity="0.35" />

        {/* світло з ящика */}
        <path className="case-crate-light" d="M70 120H290L330 -10H-10Z" fill="url(#crate-glow)" />

        <g className="case-crate-body">
            {/* торець: рамка і вміст (червоно-металеві обойми, як на оригіналі) */}
            <path d="M44 76L78 132V210L44 154Z" fill="url(#crate-end)" />
            <path d="M51 94L72 128V194L51 160Z" fill="url(#crate-ammo)" />
            <g stroke="#3d1a14" strokeOpacity="0.55" strokeWidth="1.4">
                <path d="M51 106L72 140M51 118L72 152M51 130L72 164M51 142L72 176M51 154L72 188" />
            </g>
            <g stroke="#2e2316" strokeWidth="5" strokeLinejoin="round">
                <path d="M47 82L75 134V206L47 152Z" />
            </g>

            {/* передня стінка з трьох дощок, кожна свого відтінку */}
            <path d="M78 132H292V210H78Z" fill="url(#crate-front)" />
            <rect x="78" y="132" width="214" height="26" fill="#ffffff" fillOpacity="0.05" />
            <rect x="78" y="184" width="214" height="26" fill="#000000" fillOpacity="0.07" />
            <g stroke="#3b2c1a" strokeOpacity="0.6" strokeWidth="2">
                <path d="M78 158H292M78 184H292" />
            </g>
            <g stroke="#e8cf9f" strokeOpacity="0.12" strokeWidth="1.5">
                <path d="M78 160H292M78 186H292" />
            </g>
            {/* текстура деревини */}
            <g stroke="#3b2c1a" strokeOpacity="0.2" strokeWidth="1" strokeLinecap="round">
                <path d="M88 142c20 -2 40 2 60 0M170 146c24 1 50 -2 70 1M96 170c30 2 52 -1 80 0M200 194c22 -1 44 2 82 0M90 200c18 1 30 -1 44 0M260 166c12 1 20 -1 28 0" />
            </g>
            {/* трафарет між планками */}
            <text x="190" y="176" textAnchor="middle" fill="#2a1c0e" fillOpacity="0.55" fontSize="14" fontWeight="900" fontFamily="Montserrat, sans-serif" letterSpacing="3.5">ASKOLD</text>

            {/* дві поперечні планки на передній стінці */}
            <g fill="url(#crate-batten)">
                <rect x="124" y="130" width="16" height="81" rx="1.5" />
                <rect x="242" y="130" width="16" height="81" rx="1.5" />
            </g>
            <g fill="#3b4250">
                <circle cx="132" cy="138" r="1.5" /><circle cx="132" cy="171" r="1.5" /><circle cx="132" cy="204" r="1.5" /><circle cx="250" cy="138" r="1.5" /><circle cx="250" cy="171" r="1.5" /><circle cx="250" cy="204" r="1.5" />
            </g>
            {/* правий край */}
            <path d="M289 132H293V210H289Z" fill="#4f3c25" />
        </g>

        {/* кришка */}
        <g className="case-crate-lid">
            <path d="M44 68L78 124V132L44 76Z" fill="#5a4429" />
            <path d="M78 124H292V132H78Z" fill="#7d6140" />
            <path d="M78 124H292L258 68H44Z" fill="url(#crate-top)" />
            <path d="M78 124H292L283.5 110H69.5Z" fill="#ffffff" fillOpacity="0.05" /><path d="M69.5 110H283.5L275 96H61Z" fill="#000000" fillOpacity="0.07" /><path d="M61 96H275L266.5 82H52.5Z" fill="#ffffff" fillOpacity="0.0" /><path d="M52.5 82H266.5L258 68H44Z" fill="#000000" fillOpacity="0.05" />
            <g stroke="#4a3822" strokeOpacity="0.55" strokeWidth="1.6">
                <path d="M69.5 110H283.5M61 96H275M52.5 82H266.5" />
            </g>
            <g stroke="#3b2c1a" strokeOpacity="0.15" strokeWidth="1" strokeLinecap="round">
                <path d="M90 118c26 -1 50 1 74 0M190 104c20 1 36 -1 58 0M70 90c24 1 44 -1 66 0M150 80c30 -1 60 1 90 0" />
            </g>
            <g fill="url(#crate-batten)">
                <path d="M100 124h16l-34 -56h-16z" /><path d="M178 124h16l-34 -56h-16z" /><path d="M256 124h16l-34 -56h-16z" />
            </g>
            <g fill="#7d6140">
                <rect x="100" y="124" width="16" height="9" /><rect x="178" y="124" width="16" height="9" /><rect x="256" y="124" width="16" height="9" />
            </g>
            <g fill="#3b4250">
                <circle cx="101.88" cy="113.92" r="1.4" /><circle cx="91" cy="96" r="1.4" /><circle cx="80.12" cy="78.08" r="1.4" /><circle cx="179.88" cy="113.92" r="1.4" /><circle cx="169" cy="96" r="1.4" /><circle cx="158.12" cy="78.08" r="1.4" /><circle cx="257.88" cy="113.92" r="1.4" /><circle cx="247" cy="96" r="1.4" /><circle cx="236.12" cy="78.08" r="1.4" />
            </g>
        </g>
    </svg>
);

// Тактична сітка й промені для героя сторінки
export const HeroCrateArt = () => (
    <svg className="case-hero-art" viewBox="0 0 320 200" fill="none" aria-hidden="true">
        <g stroke="currentColor" strokeOpacity="0.12" strokeWidth="1">
            {Array.from({ length: 9 }, (_, i) => <line key={`v${i}`} x1={40 + i * 30} y1="0" x2={40 + i * 30} y2="200" />)}
            {Array.from({ length: 6 }, (_, i) => <line key={`h${i}`} x1="0" y1={20 + i * 32} x2="320" y2={20 + i * 32} />)}
        </g>
        <g className="case-hero-rays" transform="translate(200 104)">
            {Array.from({ length: 12 }, (_, i) =>
                <path key={i} d="M0 0 L-9 -96 L9 -96 Z" fill="#ffc43b" fillOpacity={i % 2 ? 0.08 : 0.16} transform={`rotate(${i * 30})`} />
            )}
        </g>
        <g transform="translate(200 104)">
            <circle r="46" stroke="currentColor" strokeOpacity="0.35" strokeWidth="2" strokeDasharray="3 7" />
            <text y="16" textAnchor="middle" fontSize="48" fontWeight="900" fontFamily="Montserrat, sans-serif" fill="#ffc43b">?</text>
        </g>
        <g fill="currentColor" fillOpacity="0.55" fontSize="10" fontFamily="Montserrat, sans-serif" fontWeight="700">
            <text x="40" y="42">LOOT</text>
            <text x="262" y="186">DROP</text>
        </g>
    </svg>
);

// Замочок на кнопці відкриття: дужка — окремий шар, при наведенні на кнопку вона піднімається й відкидається
export const LockIcon = () => (
    <svg className="case-lock" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path className="case-lock-shackle" d="M7 11V7a5 5 0 0110 0v4" />
        <rect x="4" y="11" width="16" height="10" rx="2" fill="currentColor" fillOpacity="0.15" />
        <path d="M12 15v2" />
    </svg>
);

export const BoxIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 8l-9-5-9 5v8l9 5 9-5z" />
        <path d="M3 8l9 5 9-5M12 13v8" />
    </svg>
);
